import * as React from 'react';

export const VerticalDotsChunky = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="vertical-dots-chunky_svg__eds-icon--vertical-dots-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="vertical-dots-chunky_svg__eds-icon--vertical-dots-chunky_dot_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
        />
        <circle
            id="vertical-dots-chunky_svg__eds-icon--vertical-dots-chunky_dot"
            fillRule="evenodd"
            clipRule="evenodd"
            cx={12}
            cy={12}
            r={2}
        />
        <circle
            id="vertical-dots-chunky_svg__eds-icon--vertical-dots-chunky_dot_1"
            fillRule="evenodd"
            clipRule="evenodd"
            cx={12}
            cy={6}
            r={2}
        />
    </svg>
);

VerticalDotsChunky.displayName = 'VerticalDotsChunkySvg';
